import React, { Component } from 'react';
import Vas from '../../../Vas';
import $ from 'jquery';
import '../../../css/CustomerContractDetails.css';
import { TextField,ExtendedButton } from 'component-lib';
import { CurrencyConverter } from 'utils-lib';
import { RequestAjaxClass, ContractDetailsModel } from 'models-lib';

class CustomerContractDetails extends Component
{

  constructor(props)
  {
      super(props);
      this.state = {};
      this.state.Id = "";
      this.role = localStorage.getItem("vas_role");
      this.CustomerId = props.CustomerId;
      this.ContractId = props.Id;
      this.CustomerName= props.CustomerName;
      this.state.ready = false;
      this.ContractModel = new ContractDetailsModel([this]);
      this.Request = new RequestAjaxClass((error)=>{Vas.ErrorHandling(error);},null);
  }

    componentWillMount(){
        $("#LoadingIcon").removeClass().addClass('loaderSmall');
    }

    componentDidMount(){
        this.Request.setApiUrl(Vas.ApiUrl);
        this.Request.setApiKey(Vas.ApiKey);
        this.Request.setAuth(true);
        this.Request.setErrorHandler(()=>{
          $("#LoadingIcon").removeClass().addClass('hide');
        });
        this.ContractModel.SetRequest(this.Request);
        this.props.reference.setState({ ActiveRef:this });
        this.load();
    }

    Update(observer)
    {
        let me = this;
        this.setState({},()=>{
          if(observer === "ContractDetails"){

            me.refs.ContractStart.setState({ Value: me.ContractModel.Contract.DateFrom
                                                    ?me.ContractModel.Contract.DateFrom
                                                    :'' });
            me.refs.ContractEnd.setState({ Value: me.ContractModel.Contract.DateTo<me.ContractModel.Contract.DateFrom 
                                                    ? "" 
                                                    : me.ContractModel.Contract.DateTo });
            
            if (me.ContractModel.Contract.StatusId === 10){
              me.refs.State.setState({ Value:Vas.Resources.Labels["PendingApproval"] });
            } else {
              me.refs.State.setState({ Value:me.ContractModel.Contract.Status?me.ContractModel.Contract.Status:'' }); 
            }
            
            me.refs.ContractNumber.setState({ Value: me.ContractModel.Contract.ContractNumber?me.ContractModel.Contract.ContractNumber:'' });
            me.refs.NameOfBank.setState({ Value: me.ContractModel.PaymentOptionCustomer ? me.ContractModel.PaymentOptionCustomer.BankName : "" });
            me.refs.Iban.setState({ Value: me.ContractModel.PaymentOptionCustomer ? me.ContractModel.PaymentOptionCustomer.Iban: "" });
            me.refs.Bic.setState({ Value:me.ContractModel.PaymentOptionCustomer ? me.ContractModel.PaymentOptionCustomer.Bic : "" });
            me.refs.Depositor.setState({ Value: me.ContractModel.PaymentOptionCustomer ? me.ContractModel.PaymentOptionCustomer.AccountOwner : "" });
            me.refs.From.setState({ Value: me.ContractModel.ContractConnection.From?me.ContractModel.ContractConnection.From:'' });
            me.refs.To.setState({ Value: me.ContractModel.ContractConnection.To?me.ContractModel.ContractConnection.To:'' });
            me.refs.Via.setState({ Value: me.ContractModel.ContractConnection.Via?me.ContractModel.ContractConnection.Via:'' });
            me.refs.StopFrom.setState({ Value: me.ContractModel.ContractConnection.StopFrom?me.ContractModel.ContractConnection.StopFrom:'' });
            me.refs.StopTo.setState({ Value: me.ContractModel.ContractConnection.StopTo?me.ContractModel.ContractConnection.StopTo:'' });
            me.refs.ProductPrice.setState({ Value: CurrencyConverter.Cast( me.ContractModel.ContractPrice.Price, localStorage.getItem("vas_language") ,2)
                                                    ? CurrencyConverter.Cast( me.ContractModel.ContractPrice.Price, localStorage.getItem("vas_language") ,2)
                                                    :'' });
            me.refs.PriceLevel.setState({ Value: me.ContractModel.ContractPrice.PriceLevel });
            me.refs.Share1.setState({ Value:me.ContractModel.Share1?me.ContractModel.Share1:'' });
            me.refs.Share2.setState({ Value:me.ContractModel.Share2?me.ContractModel.Share2:'' });
            me.refs.School.setState({ Value:me.ContractModel.Contract.CustomerAbove?me.ContractModel.Contract.CustomerAbove:'' });
            me.refs.Type.setState({ Value:me.ContractModel.Contract.TicketName?me.ContractModel.Contract.TicketName:'' });
            if (me.ContractModel.Contract.StatusId === 10){//unbestätigt
                me.props.reference.setState({ Unbestaetigt: true });
            } else {
                if (me.ContractModel.Contract.StatusId === 1){//aktiv

                    me.props.reference.setState({ Aktive:true,FlagLoss : me.ContractModel.FlagLoss });
                }
            }
            me.setState({ FlagLoss : me.ContractModel.FlagLoss, StatusId:me.ContractModel.Contract.StatusId });
            $("#LoadingIcon").removeClass().addClass('hide');
            
            localStorage.setItem("Id_CurrentCustomer", me.ContractModel.TicketCustomer.CustomerNumber);
          }
        });
    }

    load(){
      this.ContractModel.GetContractDetailsByContractId(this.props.Id);
    }

    contractLoss(){
      Vas.GetView("LossReport",{CustomerId : this.CustomerId, ContractId: this.ContractId, CustomerName : this.CustomerName},true);
    }

    contractCancel(){
        localStorage.setItem('contract',JSON.stringify(this.ContractModel.Contract));
        Vas.GetView("ContractCancelContractCard",{CustomerId : this.CustomerId, ContractId: this.ContractId, CustomerName : this.CustomerName},true);
    }

    render()
    {

      let button = <td></td>;

      //if (localStorage.getItem('vas_role') == 1){
        if (this.state.StatusId){
          if (this.state.StatusId === 1){
            if (this.state.FlagLoss === true){
              button =(<td><table><tbody><tr>
                <td><ExtendedButton
                  Usable={true}
                  Text={Vas.Resources.Labels["ContractCancel"]}
                  Float={"right"}
                  Width={120}
                  OnClick={()=>{this.contractCancel();}} /></td>
                <td><ExtendedButton
                  Usable={true}
                  Text={Vas.Resources.Labels["ContractLoss"]}
                  Float={"right"}
                  Width={120}
                  OnClick={()=>{this.contractLoss();}} /><br /></td>
              </tr></tbody></table></td>) ;
            } else {
              button =(<td><table><tbody><tr>
                <td><ExtendedButton
                  Usable={true}
                  Text={Vas.Resources.Labels["ContractCancel"]}
                  Float={"right"}
                  Width={120}
                  OnClick={()=>{this.contractCancel();}} /></td>
              </tr></tbody></table></td>) ;
            }
          }
        }
      //}

        return (<div 
          className={""} 
          style={{ marginTop:10, marginLeft:10 }}>
          <table id={"CustomerContractDetails"}>
            <thead>
              <tr>
                <td></td>
                {button}
              </tr>
            </thead>
            <tbody>
              <tr><td 
                colSpan={2} 
                className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["ContractData"]}</b></td></tr>
              <tr>
                <td><TextField 
                  Id={"ContractNumber"} 
                  ref={"ContractNumber"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["ContractNumber"]} 
                  Editable={false} />
                </td>
                <td><TextField 
                  Id={"ProductPrice"} 
                  ref={"ProductPrice"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["ProductPrice"]} 
                  Editable={false} />
                </td>
              </tr>
              <tr>
                <td><TextField 
                  Id={"PriceLevel"} 
                  ref={"PriceLevel"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["PriceLevel"]} 
                  Editable={false} />
                </td>
                <td><TextField 
                  ref={"State"} 
                  Id={"State"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["State"]} 
                  Editable={false} /> 
                </td>
              </tr>
              <tr>
                <td><TextField 
                  Id={"ContractStart"} 
                  ref={"ContractStart"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["ContractStart"]} 
                  Editable={false} />
                </td>
                <td><TextField 
                  Id={"ContractEnd"} 
                  ref={"ContractEnd"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["ContractEnd"]} 
                  Editable={false} />
                </td>
              </tr>
              <tr>
                <td><TextField 
                  Id={"Share1"} 
                  ref={"Share1"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Share1"]} 
                  Editable={false} />
                </td>
                <td><TextField 
                  Id={"Share2"}
                  ref={"Share2"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Share2"]} 
                  Editable={false} />
                </td>
              </tr>
              <tr>
                <td colSpan={2}><TextField 
                  Id={"School"} 
                  ref={"School"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["School"]} 
                  Editable={false} 
                  Width={346} />
                </td>
              </tr>
              <tr>
                <td><TextField 
                  Id={"Type"} 
                  ref={"Type"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Type"]} 
                  Editable={false} />
                </td>
                <td>
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <table>
            <tbody>
              <tr><td 
                colSpan={2} 
                className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["ConnectionData"]}</b></td></tr>
              <tr>
                <td><TextField 
                  Id={"From"} 
                  ref={"From"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["From"]} 
                  Editable={false} />
                </td>
                <td><TextField 
                  Id={"To"} 
                  ref={"To"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["To"]} 
                  Editable={false} /> 
                </td>
              </tr>
              <tr>
                <td><TextField 
                  Id={"Via"} 
                  ref={"Via"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Via"]} 
                  Editable={false} />
                </td>
              </tr>
              <tr>
                <td colSpan={2}><TextField 
                  Id={"StopFrom"} 
                  ref={"StopFrom"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["StopFrom"]} 
                  Editable={false} 
                  Width={346} />
                </td>
              </tr>
              <tr>
                <td colSpan={2}><TextField 
                  Id={"StopTo"} 
                  ref={"StopTo"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["StopTo"]} 
                  Editable={false} 
                  Width={346} />
                </td>
              </tr>
            </tbody>
          </table>
          <br />
          <table >
            <tbody>
              <tr><td 
                colSpan={2} 
                className={"customerCardSubTitle"}><b>{Vas.Resources.Labels["MethodOfPaymentCustomer"]}</b></td></tr>
              <tr>
                <td><TextField 
                  Id={"Depositor"} 
                  ref={"Depositor"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Depositor"]} 
                  Editable={false} />
                </td>
                <td><TextField 
                  Id={"NameOfBank"} 
                  ref={"NameOfBank"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["NameOfBank"]} 
                  Editable={false} />
                </td>
              </tr>
              <tr>
                <td><TextField 
                  Id={"Iban"} 
                  ref={"Iban"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Iban"]} 
                  Editable={false} /> 
                </td>
                <td><TextField 
                  Id={"Bic"} 
                  ref={"Bic"} 
                  AppURL={Vas.ApplicationUrl} 
                  Label={Vas.Resources.Labels["Bic"]} 
                  Editable={false} /> 
                </td>
              </tr>
            </tbody>
          </table>

        </div>);
    }
}
export default CustomerContractDetails;
